import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const SettingsUsersPage = lazy(() => import('@/pages/settings/users'));

export const Route = createFileRoute('/settings/users')({
  component: function SettingsUsersRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <SettingsUsersPage />
      </Suspense>
    );
  },
});
